import React from "react";
import { CircleAlert, CircleCheckBig, Clock } from "lucide-react";

const AssessmentProgress = ({ progress = [] }) => {
  const statusStyles = {
    completed: {
      container: "bg-emerald-50 border-emerald-300",
      icon: <CircleCheckBig className="w-5 h-5 text-emerald-600" />,
    },
    current: {
      container: "bg-purple-100 border-purple-300",
      icon: <Clock className="w-5 h-5 text-purple-600" />,
    },
    upcoming: {
      container: "bg-gray-50 border-gray-200",
      icon: <CircleAlert className="w-5 h-5 text-gray-400" />,
    },
  };

  if (!progress.length) return null;

  return (
    <div className="space-y-3">

      {progress.map((step, index) => {
        const style = statusStyles[step.status] || statusStyles.upcoming;

        return (
          <div
            key={index}
            className={`p-4 border rounded-lg ${style.container}`}
          >
            <div className="flex items-start gap-3">
              {style.icon}

              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <p className="text-sm text-gray-900">{step.title}</p>
                  {step.date && (
                    <span className="text-xs text-gray-700">{step.date}</span>
                  )}
                </div>

                {step.description && (
                  <p className="text-xs text-gray-700">{step.description}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AssessmentProgress;
